import { render, staticRenderFns } from "./EditPassport.vue?vue&type=template&id=75b9371d&"
import script from "./EditPassport.vue?vue&type=script&lang=js&"
export * from "./EditPassport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports